export const OUTREACH_AGENT_METHOD_MAPPED_QUESTION_ID = 'outreach_agent_method';

export const CHAMELEON_METHOD = 'CHAMELEON';
